import { FC } from 'react';

import AddIcon from '@mui/icons-material/Add';
import { Typography } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import { GridColDef } from '@mui/x-data-grid';
import Can from 'src/components/Can';
import LinkButton from 'src/components/LinkButton';
import Table from 'src/components/Table';
import TableActions from 'src/components/Table/Actions';
import StatusIcon from 'src/components/Table/StatusIcon';
import { BASE_PERMISSIONS } from 'src/constants/permissions/base';
import useApiQueryPagination from 'src/hooks/useApiQueryPagination';
import api from 'src/services/api';
import RoleFilterSchema from 'src/validators/Role/filter.schema';

import RoleFilters from './RoleFilters';
import { Container } from './styles';

const List: FC = () => {
  const {
    handlePageChange,
    handlePageSizeChange,
    isLoading,
    data: response,
    refetch,
  } = useApiQueryPagination(api.admin.roles.useRolesQuery);

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID' },
    { field: 'name', headerName: 'Nome', flex: 2 },
    { field: 'group', headerName: 'Grupo', flex: 1 },
    {
      field: 'status',
      headerName: 'Status',
      headerAlign: 'center',
      align: 'center',
      renderCell(params) {
        return <StatusIcon status={params.row.status} />;
      },
    },
    {
      field: 'actions',
      headerName: '',
      align: 'right',
      renderCell({ id, row }) {
        return (
          <TableActions
            resourceName="Função"
            resourceId={id}
            resourceStatus={row.status}
            editLink={`/funcoes/${id}`}
            editPermissions={[BASE_PERMISSIONS.ROLES.UPDATE]}
            destroyApiEndpoint={api.admin.roles.destroyRole}
            destroyPermissions={[BASE_PERMISSIONS.ROLES.DESTROY]}
            restoreApiEndpoint={api.admin.roles.restoreRole}
            restorePermissions={[BASE_PERMISSIONS.ROLES.RESTORE]}
            descriptionPrefix={`A função ${row.name}`}
            onFinish={refetch}
          />
        );
      },
    },
  ];

  return (
    <Container>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Typography variant="h5">Funções</Typography>

            <Can
              behavior="disable"
              permissions={[BASE_PERMISSIONS.ROLES.STORE]}
            >
              <LinkButton
                to="/funcoes/novo"
                startIcon={<AddIcon />}
                color="primary"
                variant="contained"
                size="small"
              >
                Nova
              </LinkButton>
            </Can>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Table
                autoHeight
                rows={response?.data.data || []}
                pageSize={response?.data.meta.per_page}
                rowCount={response?.data.meta.total}
                columns={columns}
                loading={isLoading}
                pagination
                paginationMode="server"
                onPageChange={handlePageChange}
                onPageSizeChange={handlePageSizeChange}
                canSearch
                showFilters
                filterProps={{
                  yupSchema: RoleFilterSchema,
                  children: <RoleFilters />,
                }}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default List;
